import React, { ReactElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { getConfig } from 'src/utilities/config';

export const PXSensorScript = (): ReactElement => {
  const { pxAppUrl } = getConfig();

  return (
    <Helmet>
      <script type="text/javascript" src={pxAppUrl} async />
    </Helmet>
  );
};
